module.exports = __webpack_public_path__ + "img/publishmark.b606e876.png";